import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";

export default function TransactionHistory() {
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Container>
        <Typography variant="h5">Transaction History Page</Typography>
      </Container>
    </Box>
  );
}